import React, { useEffect } from 'react';

import { type RouteComponentProps } from 'react-router-dom';

import {
	AnalyticsEventActions,
	AnalyticsEventSource,
	sanitiseValue,
	useAnalytics,
	usePrincipalUser,
} from '@atlassian/ptc-common';

import { Redirect } from '../components/Router';

interface Props {
	contextEntryPoint: string;
}

export default function MyProfileRedirect(props: Props & RouteComponentProps) {
	const { contextEntryPoint, location } = props;

	const [{ principalUserId }] = usePrincipalUser();
	const analytics = useAnalytics();

	const url = new URL(window.location.href);
	const ref = sanitiseValue(url.searchParams.get('ref') || '', {
		shouldHaveSafeCharsOnly: true,
		shouldEncode: true,
	});

	useEffect(() => {
		analytics.pushTrackEvent({
			source: AnalyticsEventSource.USER_PROFILE_SCREEN,
			actionSubject: 'redirectMePathToMyProfile',
			action: AnalyticsEventActions.REDIRECTED,
			attributes: {
				ref,
			},
		});
	}, [analytics, ref]);

	if (!principalUserId) {
		return null;
	}

	return <Redirect to={`${contextEntryPoint}/${principalUserId}${location.search}`} />;
}
